import { registerComponent } from '@gig/magic-common';
import KeycloakErrorComponent from './keycloak-error.vue.js';

var KeycloakError = registerComponent(KeycloakErrorComponent);

export { KeycloakError };
